// frontend/src/components/chat/ChatButton.jsx
// Chat button for header with unread count badge

import React from "react";
import { useChat } from "../../contexts/ChatContext";

const ChatButton = () => {
  const { toggleChat, unreadCount, isOpen } = useChat();

  return (
    <button
      className={`btn chat-header-btn ${isOpen ? "active" : ""}`}
      onClick={toggleChat}
      title={unreadCount > 0 ? `${unreadCount} unread messages` : "Open chat"}
      aria-label={`Chat ${unreadCount > 0 ? `(${unreadCount} unread)` : ""}`}
    >
      <i className={`bi ${isOpen ? "bi-chat-fill" : "bi-chat-dots"}`}></i>
      {unreadCount > 0 && (
        <span className="chat-badge">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ChatButton;
